import { render, staticRenderFns } from "./ErrorBlock.vue?vue&type=template&id=e91a0b5c&scoped=true&"
import script from "./ErrorBlock.vue?vue&type=script&lang=js&"
export * from "./ErrorBlock.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBlock.vue?vue&type=style&index=0&id=e91a0b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91a0b5c",
  null
  
)

export default component.exports